import React, { Component } from 'react';
import * as $ from 'jquery';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import Password from './Password.js';
import SuccessDialog from './SuccessDialog.js';
import axios from 'axios';
import brandLogo from '../../images/brand-logo-dark.png';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

let cancelToken;

class PasswordContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    $(window).off("resize", this.resize);
  }

  componentDidMount() {
    $(window).resize(this.resize);
    this.resize();
    this.setModalListener();

    if (this.props.user != null) {
      this.props.handleLogoutClick();
    }
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  changePassword = (params) => {
    this.props.post(
      "/changePassword",
      params,
      this.didChangePassword,
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didChangePassword = () => {
    $('#btnSuccess').click();
  }

  getInitState = () => {
    return {
      error: "",
      password: "",
      passwordConfirm: "",
      toDashboard: false
    };
  }

  handleClearError = () => {
    this.setState({ error: "" });
  }

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  }

  handlePasswordConfirm = (event) => {
    this.setState({ passwordConfirm: event.target.value });
  }

  handlePasswordSubmit = (event) => {
    event.preventDefault();
    const { t } = this.props;

    if (this.state.password !== this.state.passwordConfirm) {
      this.setState({ error: t('guest.password.error_password') });
      return;
    }

    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*[#?!@$%^&*._-])/;
    const minLengthRegExp   = /.{8,}/;

    const passwordLength = this.state.password.length;
    const uppercasePassword = uppercaseRegExp.test(this.state.password);
    const lowercasePassword = lowercaseRegExp.test(this.state.password);
    const digitsPassword = digitsRegExp.test(this.state.password);
    const specialCharPassword = specialCharRegExp.test(this.state.password);
    const minLengthPassword = minLengthRegExp.test(this.state.password);

    if (passwordLength === 0) {
      alert("La contraseña está vacía");
      return;
    } else if (!uppercasePassword) {
      alert("La contraseña debe tenerl al menos una mayúsculas");
      return;
    } else if (!lowercasePassword) {
      alert("La contraseña debe tenerl al menos una minúsculas");
      return;
    } else if (!digitsPassword) {
      alert("La contraseña debe tenerl al menos un numero ");
      return;
    } else if (!specialCharPassword) {
      alert("La contraseña debe tenerl al menos un caracter especial");
      return;
    } else if (!minLengthPassword) {
      alert("La contraseña debe tenerl al menos 8 un caracteres");
      return;
    } 

    this.changePassword({
      password: this.state.password,
      token_id: this.props.getTokenId(),
      token_password: this.props.match.params.token_password
    });
  }

  resize = () => {
    $('#content').css({
      paddingTop: this.props.getNavbarHeight()
    });
  }

  setModalListener = () => {
    $('#modalSuccess').on('hidden.bs.modal', () => {
      this.setState({ toDashboard: true });
    });
  }

  renderFooter = () => {
    return(
      <Footer />
    );
  }

  renderNavbar = () => {
    return(
      <Navbar
        handleLanguageChange={this.props.handleLanguageChange}
        lang={this.props.lang} />
    );
  }

  renderPassword = () => {
    return(
      <Password
        error={this.state.error}
        handleClearError={this.handleClearError}
        handlePasswordChange={this.handlePasswordChange}
        handlePasswordConfirm={this.handlePasswordConfirm}
        handlePasswordSubmit={this.handlePasswordSubmit}
        password={this.state.password}
        passwordConfirm={this.state.passwordConfirm} />
    );
  }

  renderSuccessDialog = () => {
    return(
      <SuccessDialog />
    );
  }

  render() {
    if (this.state.toDashboard) {
      return <Redirect to="/marketplace" />;
    }

    return(
      <div>
        {this.renderNavbar()}
        <div className="container-fluid" id="content">
          <div className="text-center">
            <img alt="IOS OFFICES" height="200px" src={brandLogo} />
          </div>
          {this.renderPassword()}
          {this.renderSuccessDialog()}
        </div>
        {this.renderFooter()}
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(PasswordContainer);



// WEBPACK FOOTER //
// ./src/guest/password/PasswordContainer.js